import moment from 'moment'

declare module '#app' {
  // @ts-expect-error For some reason that might throw an error, though it's valid according to the docs
  interface NuxtApp {
    $moment: typeof moment
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      moment,
    },
  }
})
